import autoComplete from "@tarekraafat/autocomplete.js";

export default class Search {
	constructor() {
		this.search = document.getElementById("search");
		this.searchField = document.getElementById("search-field");
		this.closeSearch = document.getElementById("close-search");
		this.showSearch = document.getElementById("show-search");
		this.init();
	}

	init() {
		this.closeSearch.addEventListener("click", (e) => {
			this.search.classList.add("hidden");
			this.search.classList.remove("flex");
			e.preventDefault();
		});

		this.showSearch.addEventListener("click", (e) => {
			this.search.classList.remove("hidden");
			this.search.classList.add("flex");
			this.searchField.focus();
			e.preventDefault();
		});

		this.complete();
	}

	complete() {
		const formData = new FormData();
		formData.append("action", "search");
		new autoComplete({
			selector: () => {
				return this.searchField;
			},
			data: {
				src: async () => {
					try {
						formData.append("term", this.searchField.value);
						const source = await fetch(EHTScripts.url.ajax, {
							body: formData,
							credentials: "same-origin",
							headers: {
								Accept: "application/json",
							},
							method: "POST",
						});
						const response = await source.json();
						return response;
					} catch (error) {
						return error;
					}
				},
			},
			resultsList: {
				maxResults: 10,
			},
			resultItem: {
				element: (item, data) => {
					item.innerHTML = data.match;
				},
			},
			threshold: 3,
			submit: true,
		});
	}
}
